module.exports = __webpack_public_path__ + "static/media/twitter-icon-newpurple.65e67995.svg";